// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteEmployeeJobHistoryMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type DeleteEmployeeJobHistoryMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'deleteEmployeeJobHistory'
>;

export const DeleteEmployeeJobHistoryDocument = /*#__PURE__*/ gql`
    mutation deleteEmployeeJobHistory($id: ID!) {
  deleteEmployeeJobHistory(id: $id)
}
    `;
export type DeleteEmployeeJobHistoryMutationFn = Apollo.MutationFunction<
  DeleteEmployeeJobHistoryMutation,
  DeleteEmployeeJobHistoryMutationVariables
>;

/**
 * __useDeleteEmployeeJobHistoryMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeJobHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeJobHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeJobHistoryMutation, { data, loading, error }] = useDeleteEmployeeJobHistoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeJobHistoryMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeJobHistoryMutation, DeleteEmployeeJobHistoryMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEmployeeJobHistoryMutation, DeleteEmployeeJobHistoryMutationVariables>(
    DeleteEmployeeJobHistoryDocument,
    options,
  );
}
export type DeleteEmployeeJobHistoryMutationHookResult = ReturnType<typeof useDeleteEmployeeJobHistoryMutation>;
export type DeleteEmployeeJobHistoryMutationOptions = Apollo.BaseMutationOptions<
  DeleteEmployeeJobHistoryMutation,
  DeleteEmployeeJobHistoryMutationVariables
>;
